import React, { useEffect, useState } from "react";
import {
  Box, Typography, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, Alert, CircularProgress
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { sharedStockGroupsApi } from "../../api/sharedStockGroups";
import Layout from "../../components/layout/Layout";
import Swal from "sweetalert2";

const SharedStockGroups = () => {
  const [groups, setGroups] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({ name: "", description: "" });
  const [submitting, setSubmitting] = useState(false);

  const fetchGroups = async () => {
    try {
      setLoading(true);
      const res = await sharedStockGroupsApi.getAll();
      if (res.success) setGroups(res.groups);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  const handleDelete = async (id: string) => {
    if (!window.confirm("Delete this group?")) return;
    try {
      await sharedStockGroupsApi.delete(id);
      fetchGroups();
    } catch (err: any) {
      Swal.fire("Error", err.response?.data?.message || err.message, "error");
    }
  };

  const handleSave = async () => {
    try {
      setSubmitting(true);
      await sharedStockGroupsApi.create(formData);
      setOpen(false);
      setFormData({ name: "", description: "" });
      fetchGroups();
    } catch (err: any) {
      Swal.fire("Error", err.response?.data?.message || err.message, "error");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout>
      <Box p={3}>
        <Box display="flex" justifyContent="space-between" mb={3}>
          <Typography variant="h4" fontWeight="bold">Shared Stock Groups</Typography>
          <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpen(true)}>Create Group</Button>
        </Box>

        {loading ? <CircularProgress /> : (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Description</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {groups.map(g => (
                  <TableRow key={g._id}>
                    <TableCell sx={{ fontWeight: "bold" }}>{g.name}</TableCell>
                    <TableCell>{g.description}</TableCell>
                    <TableCell align="right">
                      <IconButton color="error" onClick={() => handleDelete(g._id)}><DeleteIcon /></IconButton>
                    </TableCell>
                  </TableRow>
                ))}
                {groups.length === 0 && <TableRow><TableCell colSpan={3} align="center">No groups created yet.</TableCell></TableRow>}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Create Stock Group</DialogTitle>
          <DialogContent>
            <TextField fullWidth label="Group Name (e.g. CHIA_BASE)" margin="normal" value={formData.name} onChange={e => setFormData({ ...formData, name: e.target.value })} />
            <TextField fullWidth label="Description" margin="normal" value={formData.description} onChange={e => setFormData({ ...formData, description: e.target.value })} />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleSave} disabled={submitting || !formData.name}>Save</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Layout>
  );
};

export default SharedStockGroups;
